// This component collects and renders the react components on the page.

import React from 'react';
import ReactDOM from 'react-dom';
import reactComponents from '../react';

// expose this component to the window so it can be used by bcsf filters
window.compileReactComponent = (element) => {
  const componentName = element.getAttribute('data-react-component');
  const jsonPropsString = element.getAttribute('data-json-props');
  const jsonProps = jsonPropsString ? JSON.parse(jsonPropsString) : {};

  if (reactComponents) {
    const props = { ...jsonProps };

    ReactDOM.render(
      React.createElement(reactComponents[componentName], props),
      element,
    );
  } else {
    /* eslint-disable no-console */
    console.warn(`Could not find ${componentName} to load`);
    /* eslint-enable no-console */
  }
};

export default () => {
  const reactNodes = document.querySelectorAll('[data-react-component]');
  if (reactNodes.length) reactNodes.forEach((element) => window.compileReactComponent(element));
};
